import workflow from '@banking/ui/lib/workflow';
import { update } from './update';
export { createState } from './state';
export { Action, ActionCreator } from './action';
export { update } from './update';
export default (context, initialState) => workflow(update(context), initialState);